import React from 'react';
import { Row, Col } from 'reactstrap';

export default function Footer(props) {
  return (
    <Row className="bg-litegray text-center text-md-right padded-md">
      <Col>
        <small>
          Developed with &#9829; by{' '}
          <a
            href="https://diestrocorp.com.ar"
            target="_blank"
            title="DiestroCorp"
            className="color-pink"
          >
            DiestroCorp
          </a>{' '}
          - <span>{new Date().getFullYear()}</span>
        </small>
        <br />
        <a
          href="https://github.com/diestrocorleone"
          target="_blank"
          title="GitHub Diestro Corleone"
          className="color-pink"
        >
          <i className="fa-fw fa fa-github-square" />
        </a>
        <a
          href="https://www.linkedin.com/in/matias-gabriel-perez/"
          target="_blank"
          title="LinkedIn Matías Pérez"
          className="color-pink"
        >
          <i className="fa-fw fa fa-linkedin-square" />
        </a>
      </Col>
    </Row>
  );
}
